module.exports = __webpack_public_path__ + "static/media/step-4-id.0ebc657e.jpg";